/*
  DO NOT ADD A SECOND JOB THAT REWRITES .money ELEMENTS.

  It was tried on 13 Oct 2026 and it broke the store the same night. Prices
  reached $22,296 AUD on a $199 yoyo and $1,568,644 AUD on another, customers
  reported it, and a price-display banner had to go up on the site.

  Why it breaks. ".money" is the Bucks currency app's OWN hook. Two scripts
  then own the same text:

      Liquid renders $199.00
      Bucks converts it to $298.50 AUD
      this script rounds it and writes $299 AUD
      Bucks sees the change, reads $299 as the USD base, writes $448.50
      this script rounds again ... x1.5 every pass

  The guard that was supposed to stop it ("is this our own write?") never
  fires, because Bucks writes a DIFFERENT number each pass. There is no guard
  that fixes this. Never rewrite a figure another script treats as its source
  of truth.

  Rounding converted PRICES is Bucks' job and Bucks already has the feature.
  Turn it on in the app, not here. Ironhide, 13 Oct 2026.

  What is below is the original 27 Sep 2026 script, restored. It touches only
  [data-round-up], which is the free shipping threshold and nothing else.
*/
/*
  OFFSET: round a threshold up to a whole number, in whatever currency the
  shopper is seeing. Xavier, 27 Sep 2026.

  Why this is a script at all. The free shipping threshold is one number, set
  once in theme settings, but the figure a shopper reads is converted in the
  browser by the currency app long after Liquid has finished. So Liquid never
  sees S$191.66 and cannot tidy it. This waits for the app, then tidies.

  What it touches: only figures Liquid marked with data-round-up, which
  snippets/offset-money.liquid adds when it is asked for round_up. That is
  the free shipping threshold and nothing else. Prices people actually pay
  keep their cents, because a product is worth what it costs.

  Always up, never down. The real line is S$191.66. Print S$191 and somebody
  who spends exactly that is told they qualify when they do not. Print S$192
  and anyone who reaches it is over the line for certain. The cost is asking
  for a few cents more than strictly necessary, which is the right way round.
*/
(function () {
  'use strict';

  var written = new WeakMap();

  function tidy(el) {
    var text = el.textContent;
    if (written.get(el) === text) return;   // our own write, leave it be

    /* The number, with whatever sits around it. The decimal separator is the
       last . or , followed by one or two digits and nothing after, which is
       what tells 1,234.56 apart from 1.234,56. No match means the figure is
       already whole, so there is nothing to do. */
    var blob = text.match(/\d[\d.,\s]*\d|\d/);
    if (!blob) return;
    var raw = blob[0];
    var dec = raw.match(/([.,])(\d{1,2})$/);
    if (!dec) return;

    var sep = dec[1];
    var group = sep === '.' ? ',' : '.';
    var intPart = raw.slice(0, raw.length - dec[0].length);
    var digits = intPart.split(group).join('').replace(/\s/g, '');
    var n = parseInt(digits, 10);
    if (!isFinite(n)) return;
    if (parseInt(dec[2], 10) > 0) n += 1;

    // Re-group with the separator this currency was already using.
    var out = String(n).replace(/\B(?=(\d{3})+(?!\d))/g, group);
    var next = text.replace(raw, out);
    if (next === text) return;

    written.set(el, next);
    el.textContent = next;
  }

  function watch(el) {
    if (el.__roundUp) return;
    el.__roundUp = true;
    tidy(el);
    // The app rewrites after load, and again on a currency switch, so watch
    // rather than guess at a delay.
    new MutationObserver(function () { tidy(el); })
      .observe(el, { childList: true, characterData: true, subtree: true });
  }

  function scan(root) {
    var nodes = (root || document).querySelectorAll('[data-round-up]');
    Array.prototype.forEach.call(nodes, watch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }

  /* The cart drawer, the cart page and the upsell rail all redraw themselves
     from freshly rendered markup, which brings in new marked figures that the
     first scan never saw. */
  ['cart:change', 'cart:refresh', 'cart:quiet-change'].forEach(function (evt) {
    document.addEventListener(evt, function () { setTimeout(scan, 60); });
  });

  // Anything else that swaps markup in, including app embeds.
  new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      var added = records[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if (node.hasAttribute && node.hasAttribute('data-round-up')) watch(node);
        if (node.querySelectorAll) scan(node);
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
